export default "__VITE_ASSET__bfb0b379__"